import React from 'react';
import { Box, Pressable, xcss } from '@atlaskit/primitives';
import VisuallyHidden from '@atlaskit/visually-hidden';
import { varDotsMargin, varDotsSize } from './constants';
// TODO Token usages are not consistent for dots https://product-fabric.atlassian.net/browse/DSP-3180
var colorMap = {
  default: xcss({
    backgroundColor: 'color.background.neutral'
  }),
  help: xcss({
    backgroundColor: 'color.background.neutral'
  }),
  inverted: xcss({
    // @ts-expect-error
    backgroundColor: "var(--ds-icon-subtle, #626F86)"
  }),
  primary: xcss({
    backgroundColor: 'color.background.neutral'
  })
};
var selectedColorMap = {
  default: xcss({
    // @ts-expect-error
    backgroundColor: "var(--ds-icon, #44546F)"
  }),
  help: xcss({
    // @ts-expect-error
    backgroundColor: "var(--ds-icon-discovery, #8270DB)"
  }),
  inverted: xcss({
    // @ts-expect-error
    backgroundColor: "var(--ds-icon-inverse, #FFFFFF)"
  }),
  primary: xcss({
    // @ts-expect-error
    backgroundColor: "var(--ds-icon-brand, #0C66E4)"
  })
};
var commonStyles = xcss({
  width: "var(".concat(varDotsSize, ")"),
  height: "var(".concat(varDotsSize, ")"),
  position: 'relative',
  borderRadius: 'border.radius.circle',
  '::before': {
    display: 'block',
    width: "calc(var(".concat(varDotsSize, ") + var(").concat(varDotsMargin, "))"),
    height: "calc(var(".concat(varDotsSize, ") + var(").concat(varDotsMargin, "))"),
    position: 'absolute',
    content: '""',
    insetBlockStart: "calc(-1 * var(".concat(varDotsMargin, ") / 2)"),
    insetInlineStart: "calc(-1 * var(".concat(varDotsMargin, ") / 2)")
  }
});
var buttonStyles = xcss({
  padding: 'space.0',
  border: 0,
  cursor: 'pointer',
  outline: 0
});
/**
 * __Presentational indicator__
 *
 * A presentational indicator with no interactivity
 */
export var PresentationalIndicator = function PresentationalIndicator(_ref) {
  var appearance = _ref.appearance,
    isSelected = _ref.isSelected,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Box, {
    testId: testId,
    xcss: [commonStyles, appearance === 'default' && !isSelected && colorMap['default'], appearance === 'help' && !isSelected && colorMap['help'], appearance === 'inverted' && !isSelected && colorMap['inverted'], appearance === 'primary' && !isSelected && colorMap['primary'], appearance === 'default' && isSelected && selectedColorMap['default'], appearance === 'help' && isSelected && selectedColorMap['help'], appearance === 'inverted' && isSelected && selectedColorMap['inverted'], appearance === 'primary' && isSelected && selectedColorMap['primary']]
  });
};
/**
 * __Button indicator__
 *
 * An interactive indicator.
 */
export var ButtonIndicator = function ButtonIndicator(_ref2) {
  var appearance = _ref2.appearance,
    panelId = _ref2.panelId,
    tabId = _ref2.tabId,
    isSelected = _ref2.isSelected,
    onClick = _ref2.onClick,
    testId = _ref2.testId;
  return /*#__PURE__*/React.createElement(Pressable, {
    role: "tab",
    xcss: [commonStyles, buttonStyles, appearance === 'default' && !isSelected && colorMap['default'], appearance === 'help' && !isSelected && colorMap['help'], appearance === 'inverted' && !isSelected && colorMap['inverted'], appearance === 'primary' && !isSelected && colorMap['primary'], appearance === 'default' && isSelected && selectedColorMap['default'], appearance === 'help' && isSelected && selectedColorMap['help'], appearance === 'inverted' && isSelected && selectedColorMap['inverted'], appearance === 'primary' && isSelected && selectedColorMap['primary']],
    "aria-controls": panelId,
    "aria-selected": isSelected,
    id: tabId,
    onClick: onClick,
    tabIndex: isSelected ? -1 : undefined,
    testId: testId
  }, /*#__PURE__*/React.createElement(VisuallyHidden, null, tabId));
};